module.exports = __webpack_public_path__ + "static/media/18ECA38.9beb8484.jpg";